module.exports = __webpack_public_path__ + "f3f3efab8d9b0cb53ef6f4cc4659ef04.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2023_teaser_image.jpg
// module id = 575
// module chunks = 0